import { sameBlank } from "./blanks";

// iPhones only bring up the keyboard for a text box focused during the tap itself.
// When the box a tap is for isn't on the page yet, a stand-in takes the focus (and
// brings the keyboard up) until the real box can take over.
let standIn = null;

export function focusForTyping(id) {
  const target = document.getElementById(id);
  if (target) {
    target.focus({ preventScroll: true });
    return;
  }
  if (!standIn) {
    standIn = document.createElement("input");
    standIn.type = "text";
    standIn.tabIndex = -1;
    standIn.autocomplete = "off";
    standIn.setAttribute("aria-hidden", "true");
    // Where the real box will appear, so the page has no reason to scroll to it
    Object.assign(standIn.style, {
      position: "fixed",
      left: "0",
      bottom: "0",
      width: "1px",
      height: "1px",
      opacity: "0",
      border: "0",
      padding: "0",
      fontSize: "16px",
      pointerEvents: "none",
    });
    document.body.appendChild(standIn);
  }
  standIn.focus({ preventScroll: true });
  // If nothing takes over, don't leave the keyboard up for a box nobody can see
  setTimeout(() => {
    if (document.activeElement === standIn) standIn.blur();
  }, 1500);
}

// The element that scrolls the page around `el` (on this site usually the body)
export function scrollerOf(el) {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if (
      /(auto|scroll)/.test(overflowY) &&
      node.scrollHeight > node.clientHeight
    )
      return node;
  }
  return document.scrollingElement || document.documentElement;
}

// A blank can appear more than once (a name at the top and at the signature), so the
// one that was tapped is kept to scroll to rather than the first with that label
let tappedBlank = null;
export const rememberTappedBlank = (el) => (tappedBlank = el);
export const tappedBlankFor = (label) =>
  tappedBlank?.isConnected && sameBlank(tappedBlank.dataset.blank, label)
    ? tappedBlank
    : null;
